import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { performUpdateInventoryMini } from "../../../../graphql/inventory/inventoryCRUD";

import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";

import {
  Button,
  Confirm,
  useDataProvider,
  useNotify,
  useRedirect,
} from "react-admin";

import { DeleteIcon, RemoveIcon } from "../../../../components/common/iconography";
import { logError } from "../../../../utils/appUtils";
import { InventoryStatus, NoteType } from "../../../../utils/constants";
import { setInventoryAisleList } from "../../../../utils/locationUtils";
import { deepRedirect, trimDecimal } from "../../../../utils/utils";
import { promiseResetCapacityUsed } from "../InventoryUitls";

const useStyles = makeStyles(
  (theme) => ({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "RaDeleteWithConfirmButton" },
);

export const DeepRemoveButton = (props) => {
  return (
    <DeepDeleteButton
      {...props}
      backPath={null}
      resource="inventoryItems"
      inList={true}
    />
  );
};

export const DeepDeleteButton = ({
  backPath,
  record,
  resource,
  className,
  inventory,
  exceptions,
  setExceptions,
  inventoryItems,
  setInventoryItems,
  isSaving,
  isDeleting,
  setIsDeleting,
  inList = false,
  ...props
}) => {
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const history = useHistory();
  const notify = useNotify();
  const redirect = useRedirect();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const isDisabled = isSaving;

  const handleDialogOpen = () => {
    let messages = [];
    debugger;

    const otherDamaged = inventoryItems.items.some(
      (itm) => itm.isDamaged && itm.id !== record.id,
    );

    const totalQuantity = inventoryItems.items.reduce((sum, item) => {
      if (item.id !== record.id) {
        return sum + item.quantityOnHand;
      }
      return sum;
    }, 0);

    if (record.isDamaged && !otherDamaged) {
      messages.push("- clear Damaged exception");
    }

    if (inventory.overShipment && totalQuantity <= inventory.quantityAdvised) {
      messages.push("- clear Overshipment exception");
    }

    if (
      totalQuantity < inventory.quantityAdvised &&
      inventory.status !== InventoryStatus.IN_TRANSIT
    ) {
      messages.push("- set Undershipment exception");
    }

    if (messages.length > 0) {
      messages.unshift("Deleting this item will:");
      messages.push("Proceed?");
      const messageFragment = (
        <>
          {messages.map((msg, index) => (
            <React.Fragment key={index}>
              {msg} <br />
            </React.Fragment>
          ))}
        </>
      );
      setMessage(messageFragment);
      setOpen(true);
    } else handleDelete();
  };
  const handleDialogClose = () => setOpen(false);

  const handleDelete = async (event) => {
    setIsDeleting(true);
    setOpen(false);
    try {
      debugger;
      const inventoryToUpdate = inventory;

      await dataProvider.delete(resource, {
        id: record.id,
        previousData: record,
      });

      // Filter out inventoryItem to delete
      if (inventoryItems?.items.length > 0) {
        // REMOVE from list
        inventoryItems.items = inventoryItems.items.filter(
          (item) => item.id !== record.id,
        );
        inventoryToUpdate.inventoryItems.items = inventoryItems.items;
        setInventoryItems &&
          setInventoryItems({
            items: inventoryItems.items.sort((a, b) =>
              a.locationFullName.localeCompare(b.locationFullName),
            ),
          });
      } else if (inventoryToUpdate?.inventoryItems?.items) {
        // DELETE from InventoryItem
        inventoryToUpdate.inventoryItems.items =
          inventoryToUpdate.inventoryItems.items.filter(
            (item) => item.id !== record.id,
          );
      }

      const totalQuantity = inventoryToUpdate.inventoryItems.items.reduce(
        (sum, item) => sum + item.quantityOnHand,
        0,
      );
      if (
        record.status !== InventoryStatus.IN_TRANSIT &&
        record.status !== InventoryStatus.ARRIVED
      ) {
        inventoryToUpdate.quantityReceived = totalQuantity;
      }

      // set/reset exceptinos.
      inventoryToUpdate.isDamaged = inventoryToUpdate.inventoryItems.items.some(
        (itm) => itm.isDamaged,
      );
      inventoryToUpdate.overShipment =
        totalQuantity > inventoryToUpdate.quantityAdvised;
      if (inventoryToUpdate.overShipment) {
        inventoryToUpdate.overShipmentQuantity = trimDecimal(
          totalQuantity - inventoryToUpdate.quantityAdvised,
          3,
        );
        // reset undershipment
        inventoryToUpdate.underShipmentQuantity = 0;
        inventoryToUpdate.underShipmentNote = "";
      }

      if (inventoryToUpdate.inventoryItems.items.length === 0) {
        // reset undershipment
        inventoryToUpdate.underShipmentQuantity = 0;
        inventoryToUpdate.underShipmentNote = "";
      } else {
        inventoryToUpdate.underShipment =
          totalQuantity < inventoryToUpdate.quantityAdvised;
        if (
          inventoryToUpdate.underShipment &&
          inventoryToUpdate.status !== InventoryStatus.IN_TRANSIT
        ) {
          inventoryToUpdate.underShipmentQuantity = trimDecimal(
            inventoryToUpdate.quantityAdvised - totalQuantity,
            3,
          );
          // reset overshipment
          inventoryToUpdate.overShipmentQuantity = 0;
          inventoryToUpdate.overShipmentNote = "";
        }
      }
      inventoryToUpdate.hasException =
        inventoryToUpdate.overShipment ||
        inventoryToUpdate.underShipment ||
        inventoryToUpdate.isDamaged ||
        inventory.isRecalled ||
        inventory.otherException;

      setExceptions &&
        setExceptions({
          hasException: inventoryToUpdate.hasException,
          overShipment: inventoryToUpdate.overShipment,
          overShipmentQuantity: inventoryToUpdate.overShipmentQuantity,
          overShipmentNote: inventoryToUpdate.overShipmentNote,
          underShipment: inventoryToUpdate.underShipment,
          underShipmentQuantity: inventoryToUpdate.underShipmentQuantity,
          underShipmentNote: inventoryToUpdate.underShipmentNote,
          isDamaged: inventoryToUpdate.isDamaged,
          isRecalled: record.isRecalled,
          recallNote: record.recallNote,
          otherException: record.otherException,
          otherExceptionNote: record.otherExceptionNote,
        });

      setInventoryAisleList(inventoryToUpdate);
      inventoryToUpdate.history = [
        ...inventoryToUpdate.history,
        {
          type: NoteType.INVENTORY,
          date: new Date(),
          by: window.appUser?.fullName,
          text: `Deleted ${record.quantityOnHand} ${inventoryToUpdate.inventoryUOM} from ${record.locationFullName}`,
        },
      ];
      await performUpdateInventoryMini(inventoryToUpdate);

      // update location capacityUsed/Allocated for STRUCTURED && ! OTHER || BULK
      await promiseResetCapacityUsed(inventory, record);

      notify("Item deleted successfully", "success");
      if (backPath) deepRedirect(history, backPath);
    } catch (err) {
      logError(
        "inventoryItems:DeepDeleteButton:handleDelete",
        err,
        notify,
        redirect,
      );
    } finally {
      setIsDeleting(false);
    }
  };

  if (
    !record ||
    record.status === InventoryStatus.AGGREGATED ||
    record.status === InventoryStatus.STORED ||
    record.status === InventoryStatus.SHIPPED
  )
    return null;
  return (
    <>
      {inList ? (
        <Button
          {...props}
          label="REMOVE"
          color="default"
          disabled={isDeleting || isDisabled}
          onClick={handleDialogOpen}
        >
          <RemoveIcon />
        </Button>
      ) : (
        <Button
          {...props}
          label="Delete"
          disabled={isDeleting || isDisabled}
          onClick={handleDialogOpen}
          className={classnames(
            "ra-delete-button",
            classes.deleteButton,
            className,
          )}
        >
          <DeleteIcon />
        </Button>
      )}
      <Confirm
        isOpen={open}
        loading={isDeleting}
        title="Delete Confirmation"
        content={
          <>
            Are you sure you want to delete this Inventory Item?
            <br />
            {message}
          </>
        }
        onConfirm={handleDelete}
        onClose={handleDialogClose}
      />
    </>
  );
};
